
import jsImg from '../../assets/tech/js.png';
import phpImg from '../../assets/tech/php.png';
import reactImg from '../../assets/tech/react.png';
import nodeImg from '../../assets/tech/node.png';
import phpLaravelImg from '../../assets/tech/laravel.png';
import androidImg from '../../assets/tech/android.png';
import iosImg from '../../assets/tech/apple.png';
import awsImg from '../../assets/tech/aws.png';
import googleImg from '../../assets/tech/google.png';
import wordpress from '../../assets/tech/wordpress.png'

const technologies = () => {
    const data = [
        { image: jsImg, title: 'JavaScript' },
        { image: phpImg, title: 'PHP' },
        { image: reactImg, title: 'React JS' },
        { image: nodeImg, title: 'Node JS' },
        { image: phpLaravelImg, title: 'PHP Laravel' },
        { image: wordpress, title: 'wordpress' },
        { image: androidImg, title: 'Android' },
        { image: iosImg, title: 'iOS' },
        { image: awsImg, title: 'AWS Web Service' },
        { image: googleImg, title: 'Google Web Service' },
        
    ];

    return (
        <div className="container-fluid" style={{background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)"}}>
            <div className="container servicesContent" style={{padding:'50px'}}>
                <p style={{color:'#ffffff'}}>Techonologies</p>
                <h2 style={{color:'#ffffff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Our Tech Stack </h2>
                <div className='d-flex flex-wrap justify-content-center'>                
                {data.map((tech, index) => (
                    <div key={index} className="text-center m-3">
                        <img src={tech.image} alt={tech.title} style={{ width: "60px", height: "60px" }} />
                        <p style={{color:'#ffffff'}}>{tech.title}</p>
                    </div>
                ))}
                </div>
            </div>
        </div>
    );
};

export default technologies;
